@if (dueList$ | async) {
  @if (this.duelist.length > 0) {
    <div class="balance-summary">
      <div class="balance-header">
        <div class="today-balance">
          <div class="balance-label"> {{ 'knbrAccountSummary.label.accountTodaysBalance' | cxTranslate }}</div>
          <div class="balance-amount"> {{ this.totalBalance[0]?.value }}</div>
        </div>
      </div>
      <div class="due-items-section">
        <div class="due-items-label">{{ 'knbrAccountSummary.label.accountDueItems' | cxTranslate }}</div>
        @if (this.duelist) {
          <div class="aging-buckets">
            @for (due of this.duelist; track due; let i = $index) {
              <div class="aging-bucket">
                <div class="bucket-label">{{ due.name }}</div>
                <div class="bucket-amount">{{ formatValue(due?.value) }}</div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
}